import { getApi } from 'common/api-common'
import { blobbyStrings } from './strings'

const defaultStrings = {
  alwaysInnovating: 'Always Innovating',
  bursaryProgram: 'Bursary program',
  businessSupportForSustainableGrowth:
    'Business Support for sustainable growth and community engagement',
  everythingWeDo:
    'Everything we do is to make it easier to start a <br class="d-md-none"/> business <br class="d-md-block d-none"/> and provide you with the tools to succeed.',
  forSustainableGrowthContent: `<p class="mb-lg-8 mb-4">Business support is an important feature of the Hoxton Mix. Member benefits include mentoring, networking events, workshops and introductions to investors.
</p><p class="mb-lg-8 mb-4">
We provide mentoring via a supply of experienced entrepreneurs as well as drop-in surgeries from partners such as Amazon AWS, Linkilaw and Crunch covering advice on legal, accounting and intellectual property.
</p><p>
Our community also benefit from seminars, weekly networking and informal mentoring. Peer support is common, with members swapping skills and advice.
</p>`,
  forYourTeam: 'For your team',
  helpingStartups: 'Helping start-ups and micro businesses',
  helpingTheCommunity: 'Helping the community',
  jobCreationAndEconomicGrowth:
    'Job creation and economic growth, with our level up bursary program',
  jobCreationAndEconomicGrowthContent: `<p class="mb-lg-10 mb-4">Helping start-ups and micro businesses is attractive <br class="d-xxxl-block d-none"/> since it can drive new job creation and economic growth.
</p><p>
The Level Up Bursary Programme ensures the workspace is genuinely affordable for micro and small businesses and provides opportunities for local residents from lesser opportunity backgrounds.
</p>`,
  ourPartners: 'Our Partners',
  ourPartnersSubtitle:
    'We enjoy great relationships with the <br class="d-sm-block d-none"/> following organisations.',
  relationships: 'Relationships',
  seoDescription: `Hoxton Mix offers diverse business support with mentoring, workshops, and a bursary program for sustainable growth.`,
  seoTitle: 'Business Support | Hoxton Mix',
  support: 'Support',
  theSupportDescription:
    '<span class="color-blue">INVESTORS,</span> WORKSPACE,  <br class="d-md-block d-none"/> <span class="color-yellow2">KNOWLEDGE</span>, MENTORING, <span class="color-purple3">WORKSHOPS</span>, <br class="d-md-block d-none"/> <span class="color-purple2">INTRODUCTIONS</span>, ADVICE, <span class="color-teal">SEMINARS</span>',
  weEnjoyGoodRelationshipsWithTheFollowingPeoplAndOrganisations:
    'We enjoy good relationships with the following people <br class="d-sm-none" /> and organisations.',
}
export const businessSupportStrings = getApi().makeStrings({
  en: defaultStrings,
  es: blobbyStrings(defaultStrings),
})
